import React, { Component } from "react";
import propTypes from "prop-types";
import "./index.css";


/**
 * ToggleButton component represents a toggle button with multiple options.
 * @param {object} props - The props that were passed to the component.
 * @param {string} props.options - The selected option.
 * @param {string} props.value - The selected value.
 * @param {string} props.disabled - The boolean value to check whether disabled not not.
 * @param {string} props.onSelected - The function to select any option.
 * @returns {JSX.Element} The rendered component.

 */
class ToggleButton extends Component {
  constructor(props) {
    super(props);
    this.onClickTouch = this.onClickTouch.bind(this);
  }

  onClickTouch(option) {
    let { disabled, onSelected } = this.props;
    !disabled && onSelected && onSelected(option);
  }

  render() {
    let { options, value, disabled } = this.props;
    let no_of_option = options.length;
    return (
      <div className={`toggle-button-flex ${disabled ? "disabled" : ""}`}>
        {options.map((option, index) => {
          let selected = option === value;
          return (
            <div
              key={`option${index}`}
              onClick={() => !selected && this.onClickTouch(option)}
              onTouchEnd={() => !selected && this.onClickTouch(option)}
              className={`option ${selected && "selected"} ${index >= 0 && index < no_of_option - 1 && "right-border"}`}
            >
              {option}
            </div>
          );
        })}
      </div>
    );
  }
}

ToggleButton.propTypes = {
  options: propTypes.arrayOf(propTypes.string).isRequired,
  value: propTypes.string.isRequired,
  disabled: propTypes.bool,
  onSelected: propTypes.func,
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/libraries/ToggleButton/index.jsx